import React, { useEffect, useRef } from "react"
import { AnimatePresence, motion } from 'framer-motion';
import { products } from 'constants/menu';
import { Link } from 'react-router-dom';

export default function ProductList({ setShowProducts, showProducts, setShowFeatures }) {
    let ref = useRef()
  
    const listener = (e) => {
      if (!ref.current?.contains(e.target)) setShowProducts(false)
    }
  
    useEffect(() => {
      document.addEventListener('mousedown', listener);
      return () => document.removeEventListener('mousedown', listener);
    })
  
    return (
      <div
        className='mr-[32px] flex items-center cursor-pointer relative'
        ref={ref}
        onClick={() => {
          setShowFeatures(false)
          setShowProducts(!showProducts)
        }}
      >
        <span className='mr-[13px]'>Products</span>
        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1.5L6 6.5L11 1.5" stroke="#F7F9FB" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <AnimatePresence>
          {
            showProducts &&
            <motion.ul
              initial={{ height: 0 }}
              animate={{ height: 'auto', transition: { type: 'spring' } }}
              exit={{ height: 0 }}
              className='absolute top-[60px] bg-white rounded-[16px] text-dark_blue w-[240px] overflow-y-hidden'
            >
              {
                products.map((product) =>
                  <li key={product.id} className='hover:bg-purple_transparent'>
                    <Link to={`/products/${product.url}`} className='block w-full px-[16px] py-[10px] capitalize'>{product.name}</Link>
                  </li>
                )
              }
            </motion.ul>
          }
        </AnimatePresence>
      </div>
    )
  }